import { Component, OnDestroy, OnInit } from '@angular/core';

import { combineLatest, Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';

import { getQualtricsUrl, QualtricsSurvey } from '../../qualtrics/qualtrics.utils';
import { FeedbackService } from '../../services/feedback/feedback.service';

@Component({
  selector: 'fin-feedback-widget',
  templateUrl: './feedback-widget.component.html',
  styleUrls: ['./feedback-widget.component.scss'],
})
export class FeedbackWidgetComponent implements OnInit, OnDestroy {
  qualtricsUrl$: Observable<string>;
  removeGlobalListener: Function;
  openSurveyTrigger$: Subject<boolean> = new Subject();
  visibility$: Observable<boolean>;
  feedbackSurvey$: Observable<QualtricsSurvey>;

  constructor(
    private languageService: LanguageService,
    private feedbackService: FeedbackService
  ) {}

  ngOnInit(): void {
    this.visibility$ = this.feedbackService.visibility$.pipe(distinctUntilChanged());
    this.feedbackSurvey$ = this.feedbackService.feedbackSurvey$.pipe(distinctUntilChanged());

    this.qualtricsUrl$ = this.feedbackSurvey$.pipe(
      switchMap((survey) => combineLatest([this.languageService.langKey, this.languageService.translate(survey.url)])),
      map((params) => getQualtricsUrl(params[0], this.languageService.langValue, params[1]))
    );
  }

  ngOnDestroy(): void {
    if (this.removeGlobalListener) {
      this.removeGlobalListener();
    }
  }

  openModal(event: MouseEvent): void {
    event.stopPropagation();

    this.openSurveyTrigger$.next(true);
  }
}
